import React, { useState } from 'react';
import { FileDownIcon, MenuIcon, ClipboardIcon, BarChart2Icon, LayersIcon, LightbulbIcon, BoxIcon, Loader2Icon } from 'lucide-react';
import { MobileNav } from './MobileNav';
import { exportReportToPdf } from '../utils/exportPdf';
interface HeaderProps {
  timeRange: string;
  setTimeRange: (range: string) => void;
}
export const Header: React.FC<HeaderProps> = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [activeItem, setActiveItem] = useState('overview');
  const [isExporting, setIsExporting] = useState(false);
  const navItems = [{
    id: 'overview',
    label: 'Context',
    icon: ClipboardIcon,
    section: 'overview',
    href: '#overview'
  }, {
    id: 'analysis',
    label: 'Driver Analysis',
    icon: LayersIcon,
    section: 'analysis',
    href: '#analysis'
  }, {
    id: 'dynamics',
    label: 'System Dynamics',
    icon: BoxIcon,
    section: 'dynamics',
    href: '#dynamics'
  }, {
    id: 'assessment',
    label: 'Assessment',
    icon: BarChart2Icon,
    section: 'assessment',
    href: '#assessment'
  }, {
    id: 'recommendations',
    label: 'Takeaways',
    icon: LightbulbIcon,
    section: 'recommendations',
    href: '#recommendations'
  }];
  const handleExport = async () => {
    if (isExporting) return;
    setIsExporting(true);
    try {
      await exportReportToPdf('ooh-attention-report.pdf');
    } finally {
      setIsExporting(false);
    }
  };
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80; // Adjust this value based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setActiveItem(sectionId);
  };
  return <header className="bg-white border-b border-gray-100 sticky top-0 z-50" data-id="element-176">
      <div className="container mx-auto px-4" data-id="element-177">
        <div className="flex items-center justify-between h-16" data-id="element-178">
          <div className="flex items-center" data-id="element-179">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/caJJCtS3envvP8mN4NRUHS/Brandpulse_logo.png" alt="BrandPulse" className="h-6 w-auto" data-id="element-180" />
          </div>
          <nav className="hidden md:flex items-center space-x-1" data-export-hide data-id="element-181">
            {navItems.map(item => {
            const Icon = item.icon;
            return <a key={item.id} href={item.href} onClick={e => {
              e.preventDefault();
              scrollToSection(item.section);
            }} className={`flex items-center px-3 py-1.5 rounded-full text-sm transition-colors ${activeItem === item.section ? 'bg-[#1E90FF]/5 text-[#1E90FF]' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-182">
                  <Icon className="h-4 w-4 mr-2" data-id="element-183" />
                  {item.label}
                </a>;
          })}
          </nav>
          <div className="flex items-center space-x-2" data-export-hide data-id="element-184">
            <button onClick={handleExport} disabled={isExporting} aria-busy={isExporting} className="hidden md:flex items-center space-x-2 bg-white border border-[#1E90FF] text-[#1E90FF] px-4 py-2 rounded-lg font-medium hover:bg-[#1E90FF]/5 transition-colors disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-185">
              {isExporting ? <>
                  <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-186" />
                  <span data-id="element-187">Preparing…</span>
                </> : <>
                  <FileDownIcon className="h-4 w-4" data-id="element-188" />
                  <span data-id="element-189">Export PDF</span>
                </>}
            </button>
            <a href="https://create.brandpulse-analytics.com/" target="_blank" rel="noopener noreferrer" className="hidden md:block bg-[#1E90FF] text-white px-4 py-2 rounded-lg font-medium hover:bg-[#1E90FF]/90 transition-colors whitespace-nowrap" data-id="element-190">
              Create new
            </a>
            <button onClick={() => setIsMobileNavOpen(true)} className="md:hidden p-2 hover:bg-gray-50 rounded-full" data-id="element-191">
              <MenuIcon className="h-5 w-5 text-gray-600" data-id="element-192" />
            </button>
          </div>
        </div>
      </div>
      <MobileNav isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} navItems={navItems} activeItem={activeItem} setActiveItem={id => {
      setActiveItem(id);
      scrollToSection(id);
    }} data-id="element-193" />
    </header>;
};